module.exports = [
	{
		"name": "Card Swipe Safes",
		"modelThumb": "card-swipe-safes.png",
		"modelType": "modelOnly",
		"modelNo": "CA110ES",
		"serialNo": "G123456789H",
		"modelNos": [
			"CA110ES",
			"H060ES",
			"HL100ES"
		],
		"modelNumberLocation": [
			{
				"x": "30",
				"y": "120",
				"tooltip": "On the side of safe"
			}
		]
	},
	{
		"name": "Chest & File Safes",
		"modelThumb": "chest-and-file-safes.png",
		"modelType": "modelAndSerialChestFile",
		"modelNumberLocation": [
			{
				"x": "142",
				"y": "174",
				"tooltip": "On bottom of safe."
			}
		],
		"serialNumberLocation": [
			{
				"x": "110",
				"y": "70",
				"tooltip": "On inside of safe lid"
			}
		]
	},
	{
		"name": "Commercial Safes",
		"modelThumb": "commercial-safes-white.jpg",
		"modelType": "modelOnly",
		"modelNo": "S6770",
		"serialNo": "K012345",
		"modelNos": [
			"S6370",
			"S7371",
			"S8371",
			"S8771",
			"S6520",
			"S6770",
			"S7771"
		],
		"modelNumberLocation": [
			{
				"x": "50",
				"y": "40",
				"tooltip": "On the side of the safe"
			},
			{
				"x": "85",
				"y": "110",
				"tooltip": "On the inside of the door"
			}
		]
	},
	{
		"name": "Depository Safes",
		"modelThumb": "depository-safes.png",
		"modelType": "modelOnly",
		"modelNo": "DH074E",
		"serialNo": "G123456789H",
		"modelNos": [
			"DH074E",
			"DH109E",
			"DH134E"
		],
		"modelNumberLocation": [
			{
				"x": "50",
				"y": "25",
				"tooltip": "On the back of the safe"
			}
		]
	},
	{
		"name": "Electronic Security Boxes",
		"modelThumb": "electronic-security-boxes.png",
		"modelType": "modelOnly",
		"modelNo": "ESB3",
		"serialNo": "G1234567895",
		"modelNos": [
			"ESB3",
			"P008E",
			"P021E",
			"P005K",
			"P008EML",
			"PL048E"
		],
		"modelNumberLocation": [
			{
				"x": "45",
				"y": "150",
				"tooltip": "On the side of the safe"
			},
			{
				"x": "150",
				"y": "160",
				"tooltip": "On the bottom of the safe"
			}
		]
	},
	{
		"name": "Executive Digital Fire Safe",
		"modelThumb": "executive-digital-fire-safe.png",
		"modelType": "modelOnly",
		"modelNo": "EF3428E",
		"serialNo": "G123456789H",
		"modelNos": [
			"EF3025E",
			"EF3428E",
			"EF4738E"
		],
		"modelNumberLocation": [
			{
				"x": "50",
				"y": "45",
				"tooltip": "On the side or back of the safe"
			},
			{
				"x": "50",
				"y": "178",
				"tooltip": "On the side or back of the safe"
			}
		]
	},
	{
		"name": "SF/SFW Safes",
		"modelThumb": "fire-safes.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "75",
				"y": "150",
				"tooltip": "Inside the safe on the back of the door"
			},
			{
				"x": "180",
				"y": "110",
				"tooltip": "Along the hinge of the door"
			}
		],
		"serialNumberLocation": [
			{
				"x": "187",
				"y": "172",
				"tooltip": "Lower right hand corner of safe door"
			},
			{
				"x": "145",
				"y": "110",
				"tooltip": "Bottom lip of keypad/faceplate"
			},
			{
				"x": "77",
				"y": "164",
				"tooltip": "Inside right corner of front door"
			}
		]
	},
	{
		"name": "FP/FPW Safes",
		"modelThumb": "fire-safes-fp.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "110",
				"y": "40",
				"tooltip": "On the top of the safe"
			},
			{
				"x": "130",
				"y": "150",
				"tooltip": "On the front of the safe"
			}
		],
		"serialNumberLocation": [
			{
				"x": "110",
				"y": "40",
				"tooltip": "On the top of the safe"
			},
			{
				"x": "130",
				"y": "150",
				"tooltip": "On the front of the safe"
			}
		]
	},
	{
		"name": "Fire Safes With USB Port",
		"modelThumb": "fire-safes-with-usb.png",
		"modelType": "modelAndSerial",
		"seeMoreLink": {
			"text": "Example of Model & Serial Number",
			"image": "firesafes_usb_port-ex.png"
		},
		"modelNumberLocation": [
			{
				"x": "70",
				"y": "150",
				"tooltip": "Inside the safe on the back of the door"
			},
			{
				"x": "167",
				"y": "100",
				"tooltip": "Along the hinge of the door"
			}
		],
		"serialNumberLocation": [
			{
				"x": "70",
				"y": "150",
				"tooltip": "Inside the safe on the back of the door"
			},
			{
				"x": "130",
				"y": "130",
				"tooltip": "Below the keypad"
			},
			{
				"x": "167",
				"y": "100",
				"tooltip": "Along the hinge of the door"
			}
		]
	},
	{
		"name": "Floor Safes",
		"modelThumb": "floor-safes.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "143",
				"y": "16",
				"tooltip": "On side of handle"
			}
		],
		"serialNumberLocation": [
			{
				"x": "143",
				"y": "16",
				"tooltip": "On side of handle"
			}
		]
	},
	{
		"name": "Gun Safes Electronic & Manual Dial Lock",
		"modelThumb": "gun-safes-electronic-lock.png",
		"modelType": "modelAndSerial",
		"seeMoreLink": {
			"text": "Example of Model & Serial Number",
			"image": "gun-safes-electronic-lock-ex.png"
		},
		"modelNumberLocation": [
			{
				"x": "78",
				"y": "9",
				"tooltip": "On the back, near top corner"
			}
		],
		"serialNumberLocation": [
			{
				"x": "80",
				"y": "30",
				"tooltip": "On back of safe"
			},
			{
				"x": "80",
				"y": "110",
				"tooltip": "On the side of safe"
			}
		]
	},
	{
		"name": "Home Defense Center",
		"modelThumb": "home-defense-center.png",
		"modelType": "modelOnly",
		"modelNo": "HDC11E",
		"serialNo": "C123GC01234",
		"modelNos": [
			"HDC11E"
		],
		"modelNumberLocation": [
			{
				"x": "90",
				"y": "20",
				"tooltip": "On back of safe"
			},
			{
				"x": "140",
				"y": "50",
				"tooltip": "Along the hinge of safe"
			},
			{
				"x": "130",
				"y": "200",
				"tooltip": "On the side of safe"
			}
		]
	},
	{
		"name": "Pistol & Drawer Safes",
		"modelThumb": "pistol-and-drawer-safes.png",
		"modelType": "modelOnly",
		"modelNo": "QAP1BE",
		"serialNo": "G1234567890A",
		"modelNos": [
			"MLD08E",
			"PP1K",
			"QAP1BLX",
			"QAP2BLX",
			"MLD08EB",
			"PP1KML",
			"QAP1E",
			"QAP2E",
			"P100",
			"QAP1BE",
			"QAP2BEL",
			"QAP2EL"
		],
		"modelNumberLocation": [
			{
				"x": "170",
				"y": "67",
				"tooltip": "On back of safe"
			}
		]
	},
	{
		"name": "T-Line Security Safes",
		"modelThumb": "t-line-safes.png",
		"modelType": "modelOnly",
		"modelNo": "T8331",
		"serialNo": "K123456789M",
		"modelNos": [
			"T0-331",
			"T5-130",
			"T6-331",
			"TW8-331",
			"T1-100",
			"T5-330",
			"T8-331",
			"T2-330",
			"T6-3L1",
			"TC8-331",
			"T3-130",
			"T6-3P1",
			"TC8-939"
		],
		"modelNumberLocation": [
			{
				"x": "125",
				"y": "35",
				"tooltip": "On back of safe"
			},
			{
				"x": "185",
				"y": "180",
				"tooltip": "On the side of safe"
			}
		]
	},
	{
		"name": "V-Line Safes",
		"modelThumb": "v-line-safes.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "208",
				"y": "130",
				"tooltip": "Right side or on the back"
			}
		],
		"serialNumberLocation": [
			{
				"x": "206",
				"y": "140",
				"tooltip": "On the side of the safe"
			},
			{
				"x": "175",
				"y": "122",
				"tooltip": "Peel back the sticker on dial"
			},
			{
				"x": "140",
				"y": "40",
				"tooltip": "On the back of safe"
			}
		]
	},
	{
		"name": "Wall Safes",
		"modelThumb": "wall-safes.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "60",
				"y": "50",
				"tooltip": "On the front of safe"
			},
			{
				"x": "140",
				"y": "165",
				"tooltip": "On the back of door inside"
			}
		],
		"serialNumberLocation": [
			{
				"x": "173",
				"y": "173",
				"tooltip": "Lower right corner below door"
			}
		]
	},
	{
		"name": "X-Line Safes",
		"modelThumb": "x-line-safes.png",
		"modelType": "modelOnly",
		"modelNo": "X055",
		"serialNo": "L123456789E",
		"modelNos": [
			"X014E",
			"X055",
			"X105",
			"X031",
			"X075",
			"X105P",
			"X041E",
			"X075ML",
			"X125"
		],
		"modelNumberLocation": [
			{
				"x": "213",
				"y": "160",
				"tooltip": "On the side of safe"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/support/findModelSerialNumber/modelAndSerialData.json
// module id = 750
// module chunks = 0